import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Modal from 'react-modal';
import { getModalStyling } from '../../../../../shared/utils/ModalUtils';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import VerbHeading from '../../../../../shared/components/VerbHeading';

const MultiCompanyConfirmationModal = (props) => {
    const { isOpen, toggleModal, onSubmit } = props;
    const handleSubmit = ({ isMCC }) => {
        onSubmit(isMCC).then(() => toggleModal(false));
    };
    return (
        <Modal
            className={cns('verb-modal admin-to-users-email-modal admin-modal mcc-modal')}
            style={getModalStyling({ content: { width: '700px' } })}
            isOpen={isOpen}
            contentLabel={'Modal'}
        >
            <div className={'close-container'}>
                <i className={'fal fa-times'} onClick={() => toggleModal(false)} />
            </div>
            <div className={'baseModal main-panel'}>
                <div className={'row'}>
                    <VerbHeading
                        className={'modal-header'}
                        messageId={'CREATE_MULTICOMPANY_TEAM'}
                        defaultMessage={`Create a Multi-Company Team?`}
                        hNumber={2}
                    />
                </div>
                <br />
                <div className={'row'}></div>
                <br />
                <div className={'bottom-panel'}>
                    <div className={'row'}>
                        <VerbButton
                            className={'col-xs'}
                            textId={'BUTTON_CANCEL'}
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            defaultMessage={'CANCEL'}
                            onClick={() => toggleModal(false)}
                        />
                        <VerbButton
                            className={'col-xs ms-auto submit-button'}
                            type={'submit'}
                            textId={'BUTTON_NO'}
                            defaultMessage={'NO'}
                            fontAwesomeIcon={'fa-save'}
                            onClick={() => handleSubmit({ isMCC: false })}
                        />
                        <VerbButton
                            className={'col-xs ms-auto submit-button'}
                            type={'submit'}
                            textId={'BUTTON_YES'}
                            defaultMessage={'YES'}
                            fontAwesomeIcon={'fa-save'}
                            onClick={() => handleSubmit({ isMCC: true })}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

MultiCompanyConfirmationModal.propTypes = {
    isOpen: PropTypes.bool,
    toggleModal: PropTypes.func,
    onSubmit: PropTypes.func
};

export default MultiCompanyConfirmationModal;
